import React from 'react';
import PropTypes from 'prop-types';
import { TranslatedBadge } from './translated_badge';

function SavePercentOnxTyresBadge({ percent, amountTyres }) {
    return (
        <TranslatedBadge
            type="save-percent"
            translationKey="badge-save-percent-on-x-tyres"
            placeholder={{ percent, amountTyres }}
        />
    );
}

SavePercentOnxTyresBadge.propTypes = {
    percent: PropTypes.number.isRequired,
    amountTyres: PropTypes.number.isRequired
};

export { SavePercentOnxTyresBadge };
